import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const TrashLine = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "19",
        height: "20",
        viewBox: "0 0 19 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.125 1.21252H11.875M9.5 7.62505V15.9376M12.4688 7.62505V15.9376M6.53125 7.62505V15.9376M4.75 18.7876H14.25C14.9058 18.7876 15.4375 18.2559 15.4375 17.6001V5.72508C15.4375 5.06924 14.9058 4.53758 14.25 4.53758H4.75C4.09416 4.53758 3.5625 5.06924 3.5625 5.72508V17.6001C3.5625 18.2559 4.09416 18.7876 4.75 18.7876ZM2.375 4.53758H16.625C16.9529 4.53758 17.2188 4.27175 17.2188 3.94383V2.75633C17.2188 2.42841 16.9529 2.16258 16.625 2.16258H2.375C2.04708 2.16258 1.78125 2.42841 1.78125 2.75633V3.94383C1.78125 4.27175 2.04708 4.53758 2.375 4.53758Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    });
